import React from 'react';

export default function ImageCarouselModal({ Offer, onClose }) {
    const images = Offer.images ? JSON.parse(Offer.images) : [];

    return (
        <div className="custom-modal-backdrop" style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            background: 'rgba(0, 0, 0, 0.85)', zIndex: 4000,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
            {/* Przycisk zamknięcia - wyrazisty i zawsze na wierzchu */}
            <button 
                onClick={onClose} 
                className="btn btn-danger shadow-lg" 
                style={{ 
                    position: 'absolute', top: '15px', right: '15px', 
                    zIndex: 4005, width: '45px', height: '45px', 
                    borderRadius: '50%', fontSize: '28px', lineHeight: '1',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    border: '2px solid white'
                }}
            >
                &times;
            </button>

            <div className="modal-content border-0 bg-transparent" style={{ maxWidth: '1200px', width: '100%', padding: '5px' }}>
                
                <div className="text-center mb-3 text-white px-5">
                    <h5 className="m-0 fw-bold" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>{Offer.name}</h5>
                </div>

                {images.length > 0 ? (
                    <div id="carouselExampleControls" className="carousel slide shadow-lg" data-bs-ride="carousel">
                        <div className="carousel-inner rounded-3">
                            {images.map((img, idx) => {
                                // Budowanie ścieżki i kodowanie URL
                                const baseUrl = img.includes('/') 
                                    ? `https://megamont.pl/uploads/${img}` 
                                    : `https://megamont.pl/uploads/oferta_${Offer.id}/${img}`;
                                
                                const encodedUrl = encodeURI(baseUrl);
                                
                                return (
                                    <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                                        {/* Zastosowano cudzysłowy url('${encodedUrl}'), aby obsłużyć 
                                            nazwy plików z nawiasami, np. obrazek(1).jpg 
                                        */}
                                        <div className="carousel-image-container" style={{
                                            width: '100%',
                                            height: '75vh', 
                                            backgroundImage: `url('${encodedUrl}')`,
                                            backgroundSize: 'contain', // Zmieniono na contain, aby widzieć CAŁE zdjęcie bez ucinania
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'center',
                                            backgroundColor: '#000'
                                        }}></div>
                                    </div>
                                );
                            })}
                        </div>
                        
                        {images.length > 1 && (
                            <>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon p-3 bg-dark rounded-circle" aria-hidden="true" style={{ width: '45px', height: '45px' }}></span>
                                    <span className="visually-hidden">Poprzednie</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                    <span className="carousel-control-next-icon p-3 bg-dark rounded-circle" aria-hidden="true" style={{ width: '45px', height: '45px' }}></span>
                                    <span className="visually-hidden">Następne</span>
                                </button>
                            </>
                        )}
                    </div>
                ) : (
                    <div className="alert alert-light text-center">Brak zdjęć dla tej oferty.</div>
                )}
            </div>

            <style>{`
                /* Naprawa ucinania na telefonach */
                @media (max-width: 768px) {
                    .carousel-image-container {
                        height: 50vh !important; /* Nieco większa wysokość na mobile dla lepszej widoczności */
                    }
                    .carousel-control-prev, .carousel-control-next {
                        width: 12%;
                    }
                    .carousel-control-prev-icon, .carousel-control-next-icon {
                        width: 35px !important;
                        height: 35px !important;
                    }
                }
            `}</style>
        </div>
    );
}